// login.guard.ts
import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { getEssDashboardRoute } from 'src/app/environments/environment-host';
import {
  getLoginUserDetails,
  isOnboardingCompleteFromUser,
} from 'src/app/onboarding-process/utils/onboarding.util';
import { PolicyConsentService } from 'src/app/policy-consent/policy-consent.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  constructor(
    private router: Router,
    private policyConsentService: PolicyConsentService
  ) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    const user = getLoginUserDetails();
    if (!user) {
      return true;
    }
    if (!isOnboardingCompleteFromUser(user)) {
      return this.router.createUrlTree(['/onboarding', 'welcome']);
    }

    return this.policyConsentService.hasPendingConsent().pipe(
      map((hasPending) =>
        this.router.createUrlTree(
          hasPending ? ['/policy-consent'] : getEssDashboardRoute()
        )
      ),
      catchError(() => of(this.router.createUrlTree(getEssDashboardRoute())))
    );
  }
}
